<div class="-m-6 max-w-2xl bg-white dark:bg-gray-800 overflow-hidden">

    <!-- Opened after sign-in -->
    <div *ngIf="desktopAgentService.fileOpened$ | async; else signInFlow" class="flex items-start gap-4 w-full sm:w-[42rem] p-6">
        <div class="flex items-center justify-center w-10 h-10 rounded-xl bg-green-100 dark:bg-green-900 text-green-600 dark:text-green-400 shrink-0">
            <mat-icon class="icon-size-5" svgIcon="heroicons_outline:check"></mat-icon>
        </div>
        <div class="min-w-0">
            <h2 class="text-lg font-bold text-gray-900 dark:text-white">You're signed in to LollyDrive</h2>
            <p class="text-base font-medium text-gray-600 dark:text-gray-300 mt-1">
                <ng-container *ngIf="desktopAgentService.currentFileName$ | async as fileName; else genericOpened">
                    "<span class="font-semibold text-gray-700 dark:text-gray-200">{{ fileName }}</span>" has been opened on your desktop.
                </ng-container>
                <ng-template #genericOpened>Your file has been opened on your desktop.</ng-template>
                Changes you save go straight back to LollyLaw.
            </p>
        </div>
        <button class="ml-auto p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition shrink-0"
                (click)="closeModal()">
            <mat-icon class="icon-size-5" svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
    </div>

    <ng-template #signInFlow>
    <ng-container *ngIf="desktopAgentService.installPhase$ | async as phase">

    <div *ngIf="phase === 'idle'" class="flex items-start gap-4 p-6">
        <div class="flex items-center justify-center w-10 h-10 rounded-xl bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 shrink-0">
            <mat-icon class="icon-size-5" svgIcon="mat_outline:computer"></mat-icon>
        </div>
        <div class="min-w-0">
            <h2 class="text-lg font-bold text-gray-900 dark:text-white">
                {{ (desktopAgentService.popupMode$ | async) === 'login' ? 'LollyDrive isn\'t signed in' : 'Set up LollyDrive on this computer' }}
            </h2>
            <p *ngIf="(desktopAgentService.popupMode$ | async) === 'login'; else downloadIntro"
               class="text-base font-medium text-gray-600 dark:text-gray-300 mt-1">
                Sign in to LollyDrive to open <ng-container *ngIf="desktopAgentService.currentFileName$ | async as fileName; else yourFile">"<span class="font-semibold text-gray-700 dark:text-gray-200">{{ fileName }}</span>"</ng-container><ng-template #yourFile>your file</ng-template> on your desktop.
            </p>
            <ng-template #downloadIntro>
                <p class="text-base font-medium text-gray-600 dark:text-gray-300 mt-1">
                    Follow the steps below so you can open and edit any document on your desktop.
                </p>
            </ng-template>
        </div>
        <button class="ml-auto p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition shrink-0"
                (click)="closeModal()">
            <mat-icon class="icon-size-5" svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
    </div>

    <!-- Signed-out agent footer -->
    <div *ngIf="phase === 'idle' && (desktopAgentService.popupMode$ | async) === 'login'"
         class="flex items-center justify-end gap-4 p-6 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40">
        <ng-container *ngTemplateOutlet="signInButton"></ng-container>
    </div>

    <ng-container *ngIf="phase === 'idle' && (desktopAgentService.popupMode$ | async) === 'download'">
        <!-- Steps -->
        <div class="grid grid-cols-1 sm:grid-cols-2 border-t border-gray-100 dark:border-gray-700">
            <div class="p-6 sm:border-r border-gray-100 dark:border-gray-700">
                <div class="text-sm font-bold tracking-wide text-primary uppercase">Step 1</div>
                <mat-icon class="icon-size-8 text-primary my-3" svgIcon="feather:download"></mat-icon>
                <h5 class="font-semibold text-gray-900 dark:text-white">Download and install</h5>
                <p class="text-base font-medium text-gray-600 dark:text-gray-300 mt-1">
                    Run the installer. It installs just for you, so you don't need an administrator password.
                </p>
            </div>
            <div class="p-6">
                <div class="text-sm font-bold tracking-wide text-primary uppercase">Step 2</div>
                <mat-icon class="icon-size-8 text-primary my-3" svgIcon="heroicons_outline:document"></mat-icon>
                <h5 class="font-semibold text-gray-900 dark:text-white">Your file opens</h5>
                <p class="text-base font-medium text-gray-600 dark:text-gray-300 mt-1">
                    Nothing else to sign in to. Your file opens straight away in your desktop application.
                </p>
            </div>
        </div>

        <!-- Footer -->
        <div class="flex items-center gap-4 flex-wrap p-6 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40">
            <button mat-flat-button [color]="'primary'" (click)="downloadDesktopAgent(primaryOs)">
                <span class="flex items-center gap-2">
                    <mat-icon class="icon-size-5" svgIcon="feather:download"></mat-icon>
                    <span class="text-base leading-normal">
                        Download for {{ osLabel(primaryOs) }}
                    </span>
                </span>
            </button>
            <span class="ml-auto flex items-center gap-4 text-base">
                <a *ngFor="let os of otherOsList" href="javascript:void(0)"
                   class="text-primary font-medium hover:underline"
                   (click)="downloadDesktopAgent(os)">
                    Need the {{ osLabel(os) }} version?
                </a>
            </span>
        </div>
    </ng-container>

    <!-- Downloaded -> Installing -> Sign in tracker -->
    <div *ngIf="phase !== 'idle'" class="w-full sm:w-[42rem] p-6">
        <div class="flex items-start gap-4">
            <h4 class="text-lg font-bold text-gray-900 dark:text-white">{{ installPhaseHeading(phase) }}</h4>
            <button class="ml-auto p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition shrink-0"
                    (click)="closeModal()">
                <mat-icon class="icon-size-5" svgIcon="heroicons_outline:x-mark"></mat-icon>
            </button>
        </div>

        <div class="flex items-center gap-2 mt-4">
            <!-- Downloaded: spinner while fetching -->
            <span class="flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap"
                  [ngClass]="downloadedStepState(phase) === 'now' ? 'text-primary' : 'text-gray-900 dark:text-white'">
                <span class="flex items-center justify-center w-5 h-5 rounded-full shrink-0"
                      [ngClass]="downloadedStepState(phase) === 'now' ? 'border-2 border-primary border-r-transparent animate-spin' : 'bg-green-600'">
                    <mat-icon *ngIf="downloadedStepState(phase) === 'done'" class="icon-size-4 text-white" svgIcon="heroicons_outline:check"></mat-icon>
                </span>
                {{ downloadedStepLabel(phase) }}
            </span>
            <span class="flex-1 h-0.5 bg-gray-200 dark:bg-gray-700"></span>

            <!-- Installing -->
            <span class="flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap"
                  [ngClass]="{
                      'text-gray-900 dark:text-white': installingStepState(phase) === 'done',
                      'text-primary': installingStepState(phase) === 'now',
                      'text-gray-400': installingStepState(phase) === 'pending'
                  }">
                <span class="flex items-center justify-center w-5 h-5 rounded-full shrink-0"
                      [ngClass]="{
                          'bg-green-600': installingStepState(phase) === 'done',
                          'border-2 border-primary border-r-transparent animate-spin': installingStepState(phase) === 'now',
                          'border-2 border-gray-300 dark:border-gray-600': installingStepState(phase) === 'pending'
                      }">
                    <mat-icon *ngIf="installingStepState(phase) === 'done'" class="icon-size-4 text-white" svgIcon="heroicons_outline:check"></mat-icon>
                </span>
                Installing
            </span>
            <span class="flex-1 h-0.5 bg-gray-200 dark:bg-gray-700"></span>

            <!-- Sign in -->
            <span class="flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap"
                  [ngClass]="{
                      'text-gray-900 dark:text-white': signInStepState(phase) === 'done',
                      'text-primary': signInStepState(phase) === 'now',
                      'text-gray-400': signInStepState(phase) === 'pending'
                  }">
                <span class="flex items-center justify-center w-5 h-5 rounded-full shrink-0"
                      [ngClass]="{
                          'bg-green-600': signInStepState(phase) === 'done',
                          'border-2 border-primary border-r-transparent animate-spin': signInStepState(phase) === 'now',
                          'border-2 border-gray-300 dark:border-gray-600': signInStepState(phase) === 'pending'
                      }">
                    <mat-icon *ngIf="signInStepState(phase) === 'done'" class="icon-size-4 text-white" svgIcon="heroicons_outline:check"></mat-icon>
                </span>
                Sign in
            </span>
        </div>

        <div class="h-2 rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden mt-4">
            <div class="h-full bg-primary rounded-full transition-all duration-500"
                 [style.width.%]="progressWidth(phase)"></div>
        </div>

        <!-- Banner install, signed in -->
        <div *ngIf="phase === 'ready'; else plainHint" class="mt-3">
            <p class="text-lg font-bold text-gray-900 dark:text-white">Signed in successfully</p>
            <p class="text-base text-gray-700 dark:text-gray-200 mt-1 leading-relaxed">
                Choose <span class="font-semibold text-gray-900 dark:text-white">Open on Desktop</span> on any document in LollyLaw and it opens in the app you'd normally use.
            </p>
        </div>
        <ng-template #plainHint>
            <p class="text-base font-medium text-gray-700 dark:text-gray-200 mt-3">{{ installPhaseHint(phase) }}</p>
        </ng-template>

        <!-- Nothing detected after ~2 min -->
        <div *ngIf="desktopAgentService.showInstallHelp$ | async"
             class="flex gap-3 items-start mt-4 p-3.5 rounded-xl bg-amber-50 dark:bg-amber-900/20">
            <span class="flex items-center justify-center w-6 h-6 rounded-full bg-amber-100 dark:bg-amber-900 text-amber-600 dark:text-amber-400 shrink-0">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:question-mark-circle"></mat-icon>
            </span>
            <p class="text-base text-gray-800 dark:text-gray-100 leading-relaxed">
                <span class="font-semibold text-gray-900 dark:text-white">Don't see it?</span>
                Open the file from your Downloads, or
                <a href="javascript:void(0)" class="text-primary font-medium hover:underline" (click)="redownload()">download it again</a>.
            </p>
        </div>

        <div *ngIf="phase !== 'signin' && phase !== 'ready'" class="flex gap-3 items-start mt-4 p-3.5 rounded-xl bg-primary-50 dark:bg-primary-900/20">
            <span class="flex items-center justify-center w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 shrink-0">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
            </span>
            <p class="text-base text-gray-800 dark:text-gray-100 leading-relaxed">
                <span class="font-semibold text-gray-900 dark:text-white">{{ phase === 'downloading' ? 'Once the download finishes, open the file.' : 'Open the file your browser just downloaded.' }}</span>
                LollyDrive installs itself from there — nothing to choose along the way — then asks you to sign in once<ng-container *ngIf="desktopAgentService.currentFileName$ | async">, and opens your file</ng-container>.
            </p>
        </div>

        <!-- Sign-in callout -->
        <div *ngIf="phase === 'signin'" class="flex gap-3 items-center flex-wrap mt-4 p-3.5 rounded-xl bg-primary-50 dark:bg-primary-900/20">
            <span class="flex items-center justify-center w-6 h-6 rounded-full bg-primary-100 dark:bg-primary-900 text-primary-600 dark:text-primary-400 shrink-0">
                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:information-circle"></mat-icon>
            </span>
            <p class="flex-1 min-w-0 text-base text-gray-800 dark:text-gray-100 leading-relaxed">
                <span class="font-semibold text-gray-900 dark:text-white">One more step.</span>
                Sign in with your LollyLaw username and password<ng-container *ngIf="desktopAgentService.currentFileName$ | async; else bannerHint"> and your file opens straight away.</ng-container><ng-template #bannerHint> to finish setup. Then, select <span class="font-semibold text-gray-900 dark:text-white">Open on Desktop</span> on a document in LollyDrive to open it in the app you'd normally use.</ng-template>
            </p>
            <ng-container *ngTemplateOutlet="signInButton"></ng-container>
        </div>
    </div>

    </ng-container>
    </ng-template>

    <!-- Shared sign-in button -->
    <ng-template #signInButton>
        <button mat-flat-button [color]="'primary'" class="shrink-0" (click)="openSignIn()">
            <span class="flex items-center gap-2">
                <mat-icon class="icon-size-5" svgIcon="heroicons_outline:arrow-top-right-on-square"></mat-icon>
                <span class="text-base leading-normal">Sign in to LollyDrive</span>
            </span>
        </button>
    </ng-template>
</div>
